import { useEffect, useRef, useState } from "react";

// International formatting: comma = thousands separator, dot = decimal point.
const group = (s) => {
  const [int, ...rest] = String(s).split(".");
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return rest.length ? `${grouped}.${rest.join("")}` : grouped;
};

export const NumField = ({
  value,
  onChange,
  testid,
  className = "",
  placeholder,
  align = "text-right",
  decimal = false,
  disabled = false,
}) => {
  const fmt = decimal ? (v) => String(v) : group;
  const toRaw = (v) => (v === 0 || v ? fmt(String(v)) : "");
  const [raw, setRaw] = useState(toRaw(value));
  const focused = useRef(false);

  useEffect(() => {
    if (!focused.current) setRaw(toRaw(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handle = (e) => {
    const typed = e.target.value;
    const clean = decimal ? typed : typed.replace(/,/g, "");
    if (clean !== "" && !/^\d*\.?\d*$/.test(clean)) return;
    setRaw(decimal ? clean : group(clean));
    const n = Number(clean);
    onChange(clean === "" || clean === "." || Number.isNaN(n) ? 0 : n);
  };

  return (
    <input
      data-testid={testid}
      type="text"
      inputMode="decimal"
      value={raw}
      placeholder={placeholder}
      disabled={disabled}
      onFocus={(e) => {
        focused.current = true;
        e.target.select();
      }}
      onBlur={() => {
        focused.current = false;
        setRaw(toRaw(value));
      }}
      onChange={handle}
      className={`focus-ring num rounded-xl border border-[#E1E1E6] bg-[#FAFAFA] px-3 ${align} placeholder:text-[#B0B0B8] disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
    />
  );
};

export default NumField;
